(() => {
  'use strict';
  let requestVersion = 0;

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: currency || 'USD'
    }).format(cents / 100);
  }

  function updateCart(cart) {
    if (!cart || !Number.isFinite(cart.total_price) || !Number.isFinite(cart.item_count)) return;
    document.querySelectorAll('[data-pcf-cart-count]').forEach(element => {
      element.textContent = String(cart.item_count);
    });
    document.querySelectorAll('[data-pcf-free-shipping]').forEach(meter => {
      const threshold = Number(meter.dataset.threshold);
      const subtotal = Math.max(0, cart.total_price);
      const remaining = Math.max(0, threshold - subtotal);
      const currency = cart.currency || meter.dataset.currency;
      const message = meter.querySelector('[data-pcf-shipping-message]');
      const progress = meter.querySelector('[data-pcf-shipping-progress]');
      const summary = meter.querySelector('[data-pcf-shipping-subtotal]');
      const qualified = remaining === 0;
      meter.classList.toggle('pcf-free-shipping--qualified', qualified);
      message.textContent = qualified
        ? meter.dataset.qualifiedMessage
        : meter.dataset.remainingTemplate.replace('[amount]', formatMoney(remaining, currency));
      progress.value = Math.min(subtotal, threshold);
      progress.hidden = qualified;
      summary.textContent = meter.dataset.subtotalTemplate
        .replace('[amount]', formatMoney(subtotal, currency))
        .replace('[threshold]', formatMoney(threshold, currency));
      meter.removeAttribute('aria-busy');
    });
  }

  async function refreshCart() {
    const version = ++requestVersion;
    const meters = document.querySelectorAll('[data-pcf-free-shipping]');
    meters.forEach(meter => meter.setAttribute('aria-busy', 'true'));
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (version === requestVersion) updateCart(cart);
    } catch (_) {
    } finally {
      if (version === requestVersion) meters.forEach(meter => meter.removeAttribute('aria-busy'));
    }
  }

  function initialize() {
    if (window.Notify && window.theme && !window.theme.Notify) window.theme.Notify = new window.Notify();
    const cartJson = document.querySelector('script[id^="CartJson-"]');
    if (cartJson) {
      try { updateCart(JSON.parse(cartJson.textContent)); } catch (_) {}
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('pcf:cart-added', refreshCart);
  document.addEventListener('pcf:cart-updated', event => {
    ++requestVersion;
    updateCart(event.detail?.cart);
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) refreshCart();
  });
})();
